import React from 'react';
import PageWithTitleLayout from '../Layout/PageWithTitleLayout';
import AdminUserManagements from './AdminUserManagements';
import AdminUserManagementEdit from './AdminUserManagementEdit';
import AdminUserBulkUpload from './AdminUserBulkUpload';
import AdminStoreManagements from './AdminStoreManagements';
import AdminUserManagementList from './AdminUserManagementList';
import AdminStoreBulkUpload from './AdminStoreBulkUpload';
import AdminHLG from './AdminHLG';
import AdminCompanyManagements from './AdminCompanyManagements';
import { PATHS } from '../../constants';
import { Route, Switch, Redirect } from 'react-router-dom';
import { authenticationService } from '../../Utilities/authenticationService';

const AdminSettings = () => {
    const currentUser = authenticationService.currentUserValue;
    const isMasterAdmin = currentUser?.is_admin; // Master admin check (is_admin flag)
    
    return (
        <PageWithTitleLayout title='管理者設定'>
            <Switch>
                <Route exact path={PATHS.adminUserManagements} component={AdminUserManagements} />
                <Route exact path={PATHS.adminStoreManagements} component={AdminStoreManagements} />
                <Route exact path={PATHS.adminHLG} component={AdminHLG} />
                {isMasterAdmin && (
                    <Route exact path={PATHS.adminCompanyManagements} component={AdminCompanyManagements} />
                )}
                <Route exact path={PATHS.adminStoreBulkUpload} component={AdminStoreBulkUpload} />
                <Route exact path={PATHS.adminStoreUserList} component={AdminUserManagementList} />
                <Route path={PATHS.adminUserManagementEdit} component={AdminUserManagementEdit} />
                <Route path={PATHS.adminUserBulkUpload} component={AdminUserBulkUpload} />
                {/* Redirect company admins away from company management page */}
                {!isMasterAdmin && (
                    <Route 
                        exact 
                        path={PATHS.adminCompanyManagements} 
                        render={() => <Redirect to={PATHS.adminUserManagements} />} 
                    />
                )}
            </Switch>
        </PageWithTitleLayout>
    );
}

export default AdminSettings;

